export const setToken = (token) => localStorage.setItem("pp_token", token);
export const getToken = () => localStorage.getItem("pp_token");
export const clearToken = () => localStorage.removeItem("pp_token");

export const setUser = (user) => localStorage.setItem("pp_user", JSON.stringify(user));
export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("pp_user") || "null");
  } catch {
    return null;
  }
};
export const clearUser = () => localStorage.removeItem("pp_user");

export const logout = () => {
  clearToken();
  clearUser();
};
